import React from 'react';
import { PrelanderV3Page } from '../PrelanderV3Page';

function PrelanderV5Page() {
    return (
        <PrelanderV3Page
            subscriptionPathname='subscription/v4'
            initialPrelander='v5'
        />
    )
}

export {
    PrelanderV5Page
}
